export default {
  install (Vue, options) {
    Vue.prototype.$eventHub = new Vue()
  }
}



// WEBPACK FOOTER //
// ./src/plugins/event-hub/index.js